import React, { useState } from 'react';
import FormNavigation from 'components/FormNavigation';
import { FlowComponentType } from 'routes/types';
import Button from 'components/Button';
import { PaymentSituationResult } from 'enums/StudentLoanForgivenessFlowResults';
import RadioButtonList from 'components/Common/RadioButtonList/RadioButtonList';

import QuestionsWrapper from './Wrapper/QuestionsWrapper';

import styles from './Questions.module.scss';

const options = [
  { id: PaymentSituationResult.Yes, label: 'Yes' },
  { id: PaymentSituationResult.ImAStudent, label: "No, I'm a student" },
  { id: PaymentSituationResult.Other, label: "Other situation or I'm not sure" },
];

const PaymentSituation = ({ navigationInfo, handleNext: onNext }: FlowComponentType) => {
  const [selected, setSelected] = useState<PaymentSituationResult | null>(null);

  const handleNext = () => {
    analytics.track('Student Loan Payment Situation Selected', { selected });
    onNext(selected!);
  };

  return (
    <>
      <FormNavigation {...navigationInfo} />
      <QuestionsWrapper>
        <>
          <RadioButtonList
            label="Have you ever made payments on your loans?"
            selected={selected}
            setSelected={setSelected}
            options={options}
          />
          <Button onClick={handleNext} className={styles.button}>
            Next
          </Button>
        </>
      </QuestionsWrapper>
    </>
  );
};

export default PaymentSituation;
